import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, Inject } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";
import { Subject } from "rxjs/Subject";
import { takeUntil } from "rxjs/operators";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { CoreLogService } from "../../services/log.service";
import { AccountPaymentService } from "../../services/accountPayment.service";
import {
  AccountingCustomerDataModel,
  AccountPaymentRequestDialogData,
  ACCOUNT_PAYMENT_DIALOG_DEFAULT_CANCEL_LANGKEY,
} from "../../shared/models/accountPayment.model";

/** BottomSheet confirmation for account-payment activation. Dismisses with `true` on confirm, `false` on cancel. */
@Component({
  selector: "ya-account-payment-request-dialog",
  templateUrl: "./accountPaymentRequestDialog.component.html",
  styleUrls: ["./accountPaymentRequestDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountPaymentRequestDialogComponent implements OnInit, OnDestroy {
  private _destroy$ = new Subject<void>();

  public portalTitleText: string = "";
  public portalBodyText: string = "";
  public cancelButtonLangkey: string;
  private _accountPaymentCustomer: AccountingCustomerDataModel | null = null;

  constructor(
    public bottomSheetRef: MatBottomSheetRef<AccountPaymentRequestDialogComponent, boolean>,
    private _internationalisationService: InternationalisationService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreLogService: CoreLogService,
    private _accountPaymentService: AccountPaymentService,
    @Inject(MAT_BOTTOM_SHEET_DATA) data: AccountPaymentRequestDialogData | null | undefined
  ) {
    const me = this;
    me.cancelButtonLangkey = (data && data.cancelButtonLangkey) || ACCOUNT_PAYMENT_DIALOG_DEFAULT_CANCEL_LANGKEY;
  }

  public ngOnInit(): void {
    const me = this;
    me._internationalisationService.localeChanged
      .pipe(takeUntil(me._destroy$))
      .subscribe(() => {
        me.applyTexts();
      });
    me._accountPaymentService.accountingCustomer$
      .pipe(takeUntil(me._destroy$))
      .subscribe((accountPaymentCustomer) => {
        me._accountPaymentCustomer = accountPaymentCustomer;
        me.applyTexts();
      });
  }

  private applyTexts(): void {
    const me = this;
    me.portalTitleText = me._accountPaymentCustomer ? me._accountPaymentCustomer.activationDialogTitle : "";
    me.portalBodyText = me._accountPaymentCustomer ? me._accountPaymentCustomer.activationDialogBody : "";
    me.pushChanges();
  }

  /** Confirms the action and closes the bottom sheet. Caller handles activation. */
  public confirm(): void {
    const me = this;
    me.bottomSheetRef.dismiss(true);
  }

  /** Dismisses the dialog without side effects. */
  public cancel(): void {
    const me = this;
    me.bottomSheetRef.dismiss(false);
  }

  public ngOnDestroy(): void {
    const me = this;
    me._destroy$.next();
    me._destroy$.complete();
  }

  private pushChanges(): void {
    const me = this;
    try {
      me._changeDetectorRef.detectChanges();
    } catch (e) {
      me._coreLogService.error("AccountPaymentRequestDialogComponent", "pushChanges", e);
    }
  }
}
